import * as React from 'react';

import {Nut_Mail_Sync} from 'nutshell-core/settings-constants';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';
import {Body} from 'shells/typography/body';

import {Setting} from '../../../core/setting';

const DEFAULT_VALUE = '0';

type Props = {
    /** When true, show a "saved!" toast. */
    showSavedToast: boolean;
    onError: (arg1: string) => void;
    // Need to set the name because when this component is used in the email
    // onboarding modal on the email sync settings page, the browser gets
    // confused on when buttons to set.
    radioGroupName: string;
};

EmailSyncShareSetting.defaultProps = {
    radioGroupName: 'share synced messages',
};

export function EmailSyncShareSetting(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<string | null | undefined>(null);
    const savedTimeoutRef = React.useRef();

    return (
        <Setting settingName={Nut_Mail_Sync.SETTINGS_SHARE_DEFAULT}>
            {/* @ts-expect-error */}
            {(syncAllUserEmailMessagesSetting) => {
                if (syncAllUserEmailMessagesSetting.setting) {
                    const initialLoading = syncAllUserEmailMessagesSetting.setting === undefined;
                    let selectedValue = initialLoading ? null : DEFAULT_VALUE;
                    if (
                        syncAllUserEmailMessagesSetting.setting &&
                        syncAllUserEmailMessagesSetting.setting.value !== null
                    ) {
                        selectedValue = syncAllUserEmailMessagesSetting.setting.value;
                    }
                    const disabled =
                        syncAllUserEmailMessagesSetting.isLoading ||
                        syncAllUserEmailMessagesSetting.isUpdating;

                    return (
                        <RadioGroup
                            name={props.radioGroupName}
                            selectedValue={selectedValue}
                            onChange={(newVal) => {
                                syncAllUserEmailMessagesSetting
                                    .updateSetting(newVal)
                                    .then((mutationResult) => {
                                        setValueSaved(
                                            mutationResult &&
                                                mutationResult.data &&
                                                mutationResult.data.updateSetting &&
                                                mutationResult.data.updateSetting.setting.value
                                        );
                                        if (props.showSavedToast) {
                                            if (savedTimeoutRef.current) {
                                                clearTimeout(savedTimeoutRef.current);
                                            }
                                            // @ts-expect-error
                                            savedTimeoutRef.current = setTimeout(() => {
                                                setValueSaved(null);
                                            }, 1000);
                                        }
                                    })
                                    .catch((errMsg) => {
                                        props.onError(errMsg);
                                    });
                            }}
                        >
                            <SavedSettingToast
                                state={
                                    props.showSavedToast && valueSaved === '1'
                                        ? 'complete'
                                        : 'initial'
                                }
                            >
                                <Radio value='1' disabled={disabled}>
                                    <Body>Just those to and from existing Nutshell contacts</Body>
                                </Radio>
                            </SavedSettingToast>
                            <SavedSettingToast
                                state={
                                    props.showSavedToast && valueSaved === '0'
                                        ? 'complete'
                                        : 'initial'
                                }
                            >
                                <Radio value='0' disabled={disabled}>
                                    <Body>None, I’ll manually choose which to share</Body>
                                </Radio>
                            </SavedSettingToast>
                        </RadioGroup>
                    );
                }

                return null;
            }}
        </Setting>
    );
}
